import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {NoauthroizedComponent} from "./components/noauthroized/noauthroized.component";
import {MaintenanceComponent} from "./components/maintenance/maintenance.component";

const routes: Routes = [
  { path: 'noauthorized', component: NoauthroizedComponent },
  { path: 'maintenance/:language/:email', component: MaintenanceComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
